const LANDING_BASE_URL = 'https://www.xpherium.com';

const PRODUCT_LANDING_PATHS = {
  'intelligence-navigator': '/intelligence-navigator',
  autopilot: '/autopilot',
  'data-iq': '/data-iq',
  'knowledge-iq': '/knowledge-iq',
};

export function inferProductFromPath(pathname = '') {
  const path = String(pathname || '').toLowerCase();
  if (path.startsWith('/app/autopilot') || path.startsWith('/autopilot')) return 'autopilot';
  if (path.startsWith('/app/data-iq') || path.startsWith('/data-iq')) return 'data-iq';
  if (path.startsWith('/app/knowledge-iq') || path.startsWith('/knowledge-iq')) return 'knowledge-iq';
  return 'intelligence-navigator';
}

export function normalizeProductKey(product, pathname = '') {
  const pathInferred = inferProductFromPath(pathname);
  // If URL clearly points to a standalone product, prefer that over any stale localStorage value.
  if (pathInferred !== 'intelligence-navigator') return pathInferred;

  const normalized = String(product || '').trim().toLowerCase();
  const compact = normalized.replace(/[\s_]+/g, '-');

  if (compact === 'autopilot' || compact === 'agentic-ai' || compact === 'agentic') return 'autopilot';
  if (compact === 'data-iq' || compact === 'dataiq') return 'data-iq';
  if (compact === 'knowledge-iq' || compact === 'knowledgeiq') return 'knowledge-iq';
  if (compact === 'intelligence-navigator' || compact === 'intelligencenavigator') return 'intelligence-navigator';
  if (PRODUCT_LANDING_PATHS[normalized]) return normalized;

  return pathInferred;
}

export function getProductLandingUrl(product, pathname = '', origin) {
  const resolvedProduct = normalizeProductKey(product, pathname);
  const path = PRODUCT_LANDING_PATHS[resolvedProduct];
  if ((process.env.REACT_APP_RELEASE_CHANNEL || '') === 'staging') {
    const base = String(
      origin
      || (typeof window !== 'undefined' ? window.location.origin : '')
      || ''
    ).replace(/\/+$/, '');
    if (resolvedProduct === 'intelligence-navigator') return base ? `${base}/` : '/';
    return base ? `${base}${path}` : path;
  }
  return `${LANDING_BASE_URL}${path}`;
}
